import React, { useEffect } from 'react';

import { Chip } from '@material-ui/core';
import useAsync from 'components/hooks/useAsync';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { StyledBorderedPaper, VerticallyAlignedFlexContainer } from 'styles/common';

import { MESH_RECOMMENDATIONS_TYPES, MODULE_KEYS } from 'constants/ProjectConstants';
import { getReviewFormRoute } from 'constants/helper';
import { LogoWithoutNameImage } from 'constants/icons';
import { sendClickedOnMeshRecommends } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import { getMeshRecommendations } from 'services/meshRecommends';

import { Typography13 } from 'uiToolkit/Typography';

const getMeshRecommendsTextAndUrl = ({ recommendationType, recommendationData = {} }) => {
  switch (recommendationType) {
    case MESH_RECOMMENDATIONS_TYPES.REVIEW_PUBLISHED:
      return {
        text: recommendationData?.isManager
          ? `Discuss ${recommendationData?.reportee?.firstName}\'s ${recommendationData?.reviewName} review in your 1:1`
          : `Discuss your ${recommendationData?.reviewName} review in your 1:1`,
        url: getReviewFormRoute(recommendationData?.feedbackFormId, recommendationData?.reportee?.id),
      };
    default:
      return {
        text: '',
        url: '',
      };
  }
};

const MeshRecommends = ({ reportee, oneOnOneInstanceId, isManager = false }) => {
  const { data: meshRecommendsData, isLoading, isIdle, run } = useAsync();

  const history = useHistory();

  useEffect(() => {
    if (oneOnOneInstanceId) {
      run(
        getMeshRecommendations({
          instanceId: oneOnOneInstanceId,
          module: MODULE_KEYS.ONE_ON_ONE,
        })
      );
    }
  }, [oneOnOneInstanceId, run]);

  const onClickHandler = (url) => {
    sendClickedOnMeshRecommends({
      eventProperties: {
        source: 'oneOnOne',
        type: 'None',
      },
    });
    history.push(url);
  };

  if (isLoading || !meshRecommendsData?.data?.length) {
    return null;
  }

  return (
    <StyledBorderedPaper style={{ padding: '1.125rem', margin: '1rem 0' }}>
      <VerticallyAlignedFlexContainer>
        <MeshLogoContainer>
          <img src={LogoWithoutNameImage} alt="mesh logo" style={{ width: '100%', height: '100%' }} />
        </MeshLogoContainer>
        <Typography13 weight={600} customColor={theme.palette.text.primary}>
          Mesh Recommends
        </Typography13>
        <CountChip label={meshRecommendsData?.data?.length} />
      </VerticallyAlignedFlexContainer>
      <OrderedList>
        <>
          {meshRecommendsData?.data?.map(({ feedbackFormId, reviewName }, index) => {
            const { url, text } =
              getMeshRecommendsTextAndUrl({
                recommendationType: meshRecommendsData?.recommendationType,
                recommendationData: {
                  reportee,
                  feedbackFormId,
                  reviewName,
                  isManager,
                },
              }) ?? {};
            return (
              <OrderedListElement onClick={() => onClickHandler(url)} key={`mesh-recommends-li-${1}`}>
                <Typography13 customColor="primary">{text}</Typography13>
              </OrderedListElement>
            );
          })}
        </>
      </OrderedList>
    </StyledBorderedPaper>
  );
};

const MeshLogoContainer = styled('div')`
  width: 18px;
  height: 18px;
  margin-right: 0.5rem;
`;

const CountChip = styled(Chip)`
  color: white;
  background-color: ${theme.palette.primary.main};
  font-size: 0.875rem;
  height: 1.375rem;
  margin-left: 0.75rem;
  font-weight: 600;
`;

const OrderedList = styled('ol')``;

const OrderedListElement = styled('li')`
  font-size: 14px;
  color: ${theme.palette.primary.main};
  cursor: pointer;
`;

export default MeshRecommends;
